<p-toast></p-toast>
<p-blockUI [blocked]="isLoading">
  <div class="fixed top-0 left-0 w-full h-full flex align-items-center justify-content-center z-5"
    style="background: rgba(0,0,0,0.3);">
    <i class="pi pi-spinner pi-spin" style="font-size: 2rem; color: #000"></i>
  </div>
</p-blockUI>

<div [formGroup]="testScoresForm" class="ts-wrapper">

  <div class="ts-two-col">

    <!-- ===== LEFT COLUMN: ELP ===== -->
    <div class="ts-col">

      <!-- ELP Toggle Question -->
      <div class="ts-elp-question mb-4">
        <label class="ts-elp-label">
          HAVE YOU TAKEN ANY ENGLISH LANGUAGE PROFICIENCY (ELP) TEST?
          <span class="ts-required">*</span>
        </label>
        <div class="ts-toggle-group">
          <button type="button" class="ts-toggle-btn" [class.active]="testScoresForm.get('hasELP')?.value === true"
            (click)="testScoresForm.get('hasELP')?.setValue(true); testScoresForm.markAsDirty()">Yes</button>
          <button type="button" class="ts-toggle-btn" [class.active]="testScoresForm.get('hasELP')?.value === false"
            (click)="testScoresForm.get('hasELP')?.setValue(false); testScoresForm.markAsDirty()">No</button>
        </div>
      </div>

      <!-- YES branch: ELP Scores Section -->
      <ng-container *ngIf="testScoresForm.get('hasELP')?.value === true">
        <div class="ts-card mb-4">
          <div class="ts-card-header mb-4">ENGLISH LANGUAGE PROFICIENCY SCORES</div>

          <div class="flex flex-column gap-4">

            <!-- IELTS -->
            <div class="ts-score-grid">
              <div class="ts-field-group">
                <label class="ts-field-label mb-2">IELTS OVERALL BAND SCORE</label>
                <div class="flex align-items-center">
                  <p-fileUpload class="file-upload-button1" *ngIf="!hasFile('ieltsDoc')" mode="basic"
                    chooseLabel="Upload file" chooseIcon="pi pi-upload" [auto]="true"
                    (onSelect)="onFileUpload($event, 'ieltsDoc')" styleClass="file-upload-btn"></p-fileUpload>
                  <div *ngIf="hasFile('ieltsDoc')" class="uploaded-file-pill flex align-items-center gap-2">
                    <i class="pi pi-file upload-file-icon"></i>
                    <span class="uploaded-file-name cursor-pointer"
                      (click)="openPreview(testScoresForm.get('ieltsDoc')?.value)">{{ getDisplayFileName('ieltsDoc', 'IELTS') }}</span>
                    <button pButton type="button" icon="pi pi-times"
                      class="p-button-rounded p-button-danger p-button-text uploaded-file-remove"
                      (click)="removeFileObj('ieltsDoc')"></button>
                  </div>
                </div>
                <div class="ts-error-slot">
                  <small class="p-error"
                    *ngIf="testScoresForm.get('ieltsDoc')?.hasError('docRequired')">Document is also required  </small>
                </div>
              </div>
              <div class="ts-field-group">
                <label class="ts-field-label mb-2">&nbsp;</label>
                <input pInputText class="ts-input w-full" formControlName="ieltsScore" placeholder="e.g. 7.5"
                  [ngClass]="{'ng-invalid ng-touched': testScoresForm.get('ieltsScore')?.invalid && testScoresForm.get('ieltsScore')?.touched}" />
                <div class="ts-error-slot">
                  <small class="p-error"
                    *ngIf="testScoresForm.get('ieltsScore')?.hasError('pattern') && testScoresForm.get('ieltsScore')?.touched">Only numbers allowed</small>
                  <small class="p-error"
                    *ngIf="testScoresForm.get('ieltsScore')?.hasError('scoreRequired')">Score is also required  </small>
                </div>
              </div>
            </div>

            <!-- TOEFL -->
            <div class="ts-score-grid">
              <div class="ts-field-group">
                <label class="ts-field-label mb-2">TOEFL SCORE</label>
                <div class="flex align-items-center">
                  <p-fileUpload class="file-upload-button1" *ngIf="!hasFile('toeflDoc')" mode="basic"
                    chooseLabel="Upload file" chooseIcon="pi pi-upload" [auto]="true"
                    (onSelect)="onFileUpload($event, 'toeflDoc')" styleClass="file-upload-btn"></p-fileUpload>
                  <div *ngIf="hasFile('toeflDoc')" class="uploaded-file-pill flex align-items-center gap-2">
                    <i class="pi pi-file upload-file-icon"></i>
                    <span class="uploaded-file-name cursor-pointer"
                      (click)="openPreview(testScoresForm.get('toeflDoc')?.value)">{{ getDisplayFileName('toeflDoc', 'TOEFL') }}</span>
                    <button pButton type="button" icon="pi pi-times"
                      class="p-button-rounded p-button-danger p-button-text uploaded-file-remove"
                      (click)="removeFileObj('toeflDoc')"></button>
                  </div>
                </div>
                <div class="ts-error-slot">
                  <small class="p-error"
                    *ngIf="testScoresForm.get('toeflDoc')?.hasError('docRequired')">Document is also required  </small>
                </div>
              </div>
              <div class="ts-field-group">
                <label class="ts-field-label mb-2">&nbsp;</label>
                <input pInputText class="ts-input w-full" formControlName="toeflScore" placeholder="e.g. 1450"
                  [ngClass]="{'ng-invalid ng-touched': testScoresForm.get('toeflScore')?.invalid && testScoresForm.get('toeflScore')?.touched}" />
                <div class="ts-error-slot">
                  <small class="p-error"
                    *ngIf="testScoresForm.get('toeflScore')?.hasError('pattern') && testScoresForm.get('toeflScore')?.touched">Only numbers allowed</small>
                  <small class="p-error"
                    *ngIf="testScoresForm.get('toeflScore')?.hasError('scoreRequired')">Score is also required  </small>
                </div>
              </div>
            </div>

            <!-- DUOLINGO -->
            <div class="ts-score-grid">
              <div class="ts-field-group">
                <label class="ts-field-label mb-2">DUOLINGO SCORE</label>
                <div class="flex align-items-center">
                  <p-fileUpload class="file-upload-button1" *ngIf="!hasFile('duolingoDoc')" mode="basic"
                    chooseLabel="Upload file" chooseIcon="pi pi-upload" [auto]="true"
                    (onSelect)="onFileUpload($event, 'duolingoDoc')" styleClass="file-upload-btn"></p-fileUpload>
                  <div *ngIf="hasFile('duolingoDoc')" class="uploaded-file-pill flex align-items-center gap-2">
                    <i class="pi pi-file upload-file-icon"></i>
                    <span class="uploaded-file-name cursor-pointer"
                      (click)="openPreview(testScoresForm.get('duolingoDoc')?.value)">{{ getDisplayFileName('duolingoDoc', 'Duolingo') }}</span>
                    <button pButton type="button" icon="pi pi-times"
                      class="p-button-rounded p-button-danger p-button-text uploaded-file-remove"
                      (click)="removeFileObj('duolingoDoc')"></button>
                  </div>
                </div>
                <div class="ts-error-slot">
                  <small class="p-error"
                    *ngIf="testScoresForm.get('duolingoDoc')?.hasError('docRequired')">Document is also required  </small>
                </div>
              </div>
              <div class="ts-field-group">
                <label class="ts-field-label mb-2">&nbsp;</label>
                <input pInputText class="ts-input w-full" formControlName="duolingoScore" placeholder="e.g. 7.5"
                  [ngClass]="{'ng-invalid ng-touched': testScoresForm.get('duolingoScore')?.invalid && testScoresForm.get('duolingoScore')?.touched}" />
                <div class="ts-error-slot">
                  <small class="p-error"
                    *ngIf="testScoresForm.get('duolingoScore')?.hasError('pattern') && testScoresForm.get('duolingoScore')?.touched">Only numbers allowed</small>
                  <small class="p-error"
                    *ngIf="testScoresForm.get('duolingoScore')?.hasError('scoreRequired')">Score is also required  </small>
                </div>
              </div>
            </div>

            <!-- SAT -->
            <div class="ts-score-grid">
              <div class="ts-field-group">
                <label class="ts-field-label mb-2">SAT SCORE</label>
                <div class="flex align-items-center">
                  <p-fileUpload class="file-upload-button1" *ngIf="!hasFile('satDoc')" mode="basic"
                    chooseLabel="Upload file" chooseIcon="pi pi-upload" [auto]="true"
                    (onSelect)="onFileUpload($event, 'satDoc')" styleClass="file-upload-btn"></p-fileUpload>
                  <div *ngIf="hasFile('satDoc')" class="uploaded-file-pill flex align-items-center gap-2">
                    <i class="pi pi-file upload-file-icon"></i>
                    <span class="uploaded-file-name cursor-pointer"
                      (click)="openPreview(testScoresForm.get('satDoc')?.value)">{{ getDisplayFileName('satDoc', 'SAT') }}</span>
                    <button pButton type="button" icon="pi pi-times"
                      class="p-button-rounded p-button-danger p-button-text uploaded-file-remove"
                      (click)="removeFileObj('satDoc')"></button>
                  </div>
                </div>
                <div class="ts-error-slot">
                  <small class="p-error"
                    *ngIf="testScoresForm.get('satDoc')?.hasError('docRequired')">Document is also required  </small>
                </div>
              </div>
              <div class="ts-field-group">
                <label class="ts-field-label mb-2">&nbsp;</label>
                <input pInputText class="ts-input w-full" formControlName="satScore" placeholder="e.g. 1450"
                  [ngClass]="{'ng-invalid ng-touched': testScoresForm.get('satScore')?.invalid && testScoresForm.get('satScore')?.touched}" />
                <div class="ts-error-slot">
                  <small class="p-error"
                    *ngIf="testScoresForm.get('satScore')?.hasError('pattern') && testScoresForm.get('satScore')?.touched">Only numbers allowed</small>
                  <small class="p-error"
                    *ngIf="testScoresForm.get('satScore')?.hasError('scoreRequired')">Score is also required  </small>
                </div>
              </div>
            </div>

          </div>
        </div>
      </ng-container>

    </div>
    <!-- END LEFT COLUMN -->

    <!-- ===== RIGHT COLUMN: Standardized Tests ===== -->
    <div class="ts-col">

      <!-- Standardized Test Toggle Question -->
      <div class="ts-elp-question mb-4">
        <label class="ts-elp-label">
          DO YOU HAVE ANY STANDARDIZED TEST SCORES THAT YOU WOULD LIKE TO SHARE?
          <span class="ts-required">*</span>
        </label>
        <div class="ts-toggle-group">
          <button type="button" class="ts-toggle-btn"
            [class.active]="testScoresForm.get('hasStandardizedTest')?.value === true"
            (click)="testScoresForm.get('hasStandardizedTest')?.setValue(true); testScoresForm.markAsDirty()">Yes</button>
          <button type="button" class="ts-toggle-btn"
            [class.active]="testScoresForm.get('hasStandardizedTest')?.value === false"
            (click)="testScoresForm.get('hasStandardizedTest')?.setValue(false); testScoresForm.markAsDirty()">No</button>
        </div>
      </div>

      <!-- YES branch: Standardized Test Scores -->
      <ng-container *ngIf="testScoresForm.get('hasStandardizedTest')?.value === true">
        <div class="ts-card mb-4">
          <div class="ts-card-header mb-4">STANDARDIZED TEST SCORES</div>

          <div class="flex flex-column gap-4">

            <!-- AP EXAM -->
            <div class="ts-score-grid">
              <div class="ts-field-group">
                <label class="ts-field-label mb-2">AP EXAM SCORE</label>
                <div class="flex align-items-center">
                  <p-fileUpload class="file-upload-button1" *ngIf="!hasFile('apDoc')" mode="basic"
                    chooseLabel="Upload file" chooseIcon="pi pi-upload" [auto]="true"
                    (onSelect)="onFileUpload($event, 'apDoc')" styleClass="file-upload-btn"></p-fileUpload>
                  <div *ngIf="hasFile('apDoc')" class="uploaded-file-pill flex align-items-center gap-2">
                    <i class="pi pi-file upload-file-icon"></i>
                    <span class="uploaded-file-name cursor-pointer"
                      (click)="openPreview(testScoresForm.get('apDoc')?.value)">{{ getDisplayFileName('apDoc', 'AP Exam') }}</span>
                    <button pButton type="button" icon="pi pi-times"
                      class="p-button-rounded p-button-danger p-button-text uploaded-file-remove"
                      (click)="removeFileObj('apDoc')"></button>
                  </div>
                </div>
                <div class="ts-error-slot">
                  <small class="p-error"
                    *ngIf="testScoresForm.get('apDoc')?.hasError('docRequired')">Document is also required  </small>
                </div>
              </div>
              <div class="ts-field-group">
                <label class="ts-field-label mb-2">&nbsp;</label>
                <input pInputText class="ts-input w-full" formControlName="apScore" placeholder="e.g. 7.5"
                  [ngClass]="{'ng-invalid ng-touched': testScoresForm.get('apScore')?.invalid && testScoresForm.get('apScore')?.touched}" />
                <div class="ts-error-slot">
                  <small class="p-error"
                    *ngIf="testScoresForm.get('apScore')?.hasError('pattern') && testScoresForm.get('apScore')?.touched">Only numbers allowed</small>
                  <small class="p-error"
                    *ngIf="testScoresForm.get('apScore')?.hasError('scoreRequired')">Score is also required  </small>
                </div>
              </div>
            </div>

            <!-- ACT -->
            <div class="ts-score-grid">
              <div class="ts-field-group">
                <label class="ts-field-label mb-2">ACT SCORE</label>
                <div class="flex align-items-center">
                  <p-fileUpload class="file-upload-button1" *ngIf="!hasFile('actDoc')" mode="basic"
                    chooseLabel="Upload file" chooseIcon="pi pi-upload" [auto]="true"
                    (onSelect)="onFileUpload($event, 'actDoc')" styleClass="file-upload-btn"></p-fileUpload>
                  <div *ngIf="hasFile('actDoc')" class="uploaded-file-pill flex align-items-center gap-2">
                    <i class="pi pi-file upload-file-icon"></i>
                    <span class="uploaded-file-name cursor-pointer"
                      (click)="openPreview(testScoresForm.get('actDoc')?.value)">{{ getDisplayFileName('actDoc', 'ACT') }}</span>
                    <button pButton type="button" icon="pi pi-times"
                      class="p-button-rounded p-button-danger p-button-text uploaded-file-remove"
                      (click)="removeFileObj('actDoc')"></button>
                  </div>
                </div>
                <div class="ts-error-slot">
                  <small class="p-error"
                    *ngIf="testScoresForm.get('actDoc')?.hasError('docRequired')">Document is also required  </small>
                </div>
              </div>
              <div class="ts-field-group">
                <label class="ts-field-label mb-2">&nbsp;</label>
                <input pInputText class="ts-input w-full" formControlName="actScore" placeholder="e.g. 1450"
                  [ngClass]="{'ng-invalid ng-touched': testScoresForm.get('actScore')?.invalid && testScoresForm.get('actScore')?.touched}" />
                <div class="ts-error-slot">
                  <small class="p-error"
                    *ngIf="testScoresForm.get('actScore')?.hasError('pattern') && testScoresForm.get('actScore')?.touched">Only numbers allowed</small>
                  <small class="p-error"
                    *ngIf="testScoresForm.get('actScore')?.hasError('scoreRequired')">Score is also required  </small>
                </div>
              </div>
            </div>

            <!-- GRE -->
            <div class="ts-score-grid">
              <div class="ts-field-group">
                <label class="ts-field-label mb-2">GRE TOTAL SCORE</label>
                <div class="flex align-items-center">
                  <p-fileUpload class="file-upload-button1" *ngIf="!hasFile('greDoc')" mode="basic"
                    chooseLabel="Upload file" chooseIcon="pi pi-upload" [auto]="true"
                    (onSelect)="onFileUpload($event, 'greDoc')" styleClass="file-upload-btn"></p-fileUpload>
                  <div *ngIf="hasFile('greDoc')" class="uploaded-file-pill flex align-items-center gap-2">
                    <i class="pi pi-file upload-file-icon"></i>
                    <span class="uploaded-file-name cursor-pointer"
                      (click)="openPreview(testScoresForm.get('greDoc')?.value)">{{ getDisplayFileName('greDoc', 'GRE') }}</span>
                    <button pButton type="button" icon="pi pi-times"
                      class="p-button-rounded p-button-danger p-button-text uploaded-file-remove"
                      (click)="removeFileObj('greDoc')"></button>
                  </div>
                </div>
                <div class="ts-error-slot">
                  <small class="p-error"
                    *ngIf="testScoresForm.get('greDoc')?.hasError('docRequired')">Document is also required  </small>
                </div>
              </div>
              <div class="ts-field-group">
                <label class="ts-field-label mb-2">&nbsp;</label>
                <input pInputText class="ts-input w-full" formControlName="greScore" placeholder="e.g. 1450"
                  [ngClass]="{'ng-invalid ng-touched': testScoresForm.get('greScore')?.invalid && testScoresForm.get('greScore')?.touched}" />
                <div class="ts-error-slot">
                  <small class="p-error"
                    *ngIf="testScoresForm.get('greScore')?.hasError('pattern') && testScoresForm.get('greScore')?.touched">Only numbers allowed</small>
                  <small class="p-error"
                    *ngIf="testScoresForm.get('greScore')?.hasError('scoreRequired')">Score is also required  </small>
                </div>
              </div>
            </div>

            <!-- GMAT -->
            <div class="ts-score-grid">
              <div class="ts-field-group">
                <label class="ts-field-label mb-2">GMAT SCORE</label>
                <div class="flex align-items-center">
                  <p-fileUpload class="file-upload-button1" *ngIf="!hasFile('gmatDoc')" mode="basic"
                    chooseLabel="Upload file" chooseIcon="pi pi-upload" [auto]="true"
                    (onSelect)="onFileUpload($event, 'gmatDoc')" styleClass="file-upload-btn"></p-fileUpload>
                  <div *ngIf="hasFile('gmatDoc')" class="uploaded-file-pill flex align-items-center gap-2">
                    <i class="pi pi-file upload-file-icon"></i>
                    <span class="uploaded-file-name cursor-pointer"
                      (click)="openPreview(testScoresForm.get('gmatDoc')?.value)">{{ getDisplayFileName('gmatDoc', 'GMAT') }}</span>
                    <button pButton type="button" icon="pi pi-times"
                      class="p-button-rounded p-button-danger p-button-text uploaded-file-remove"
                      (click)="removeFileObj('gmatDoc')"></button>
                  </div>
                </div>
                <div class="ts-error-slot">
                  <small class="p-error"
                    *ngIf="testScoresForm.get('gmatDoc')?.hasError('docRequired')">Document is also required  </small>
                </div>
              </div>
              <div class="ts-field-group">
                <label class="ts-field-label mb-2">&nbsp;</label>
                <input pInputText class="ts-input w-full" formControlName="gmatScore" placeholder="e.g. 7.5"
                  [ngClass]="{'ng-invalid ng-touched': testScoresForm.get('gmatScore')?.invalid && testScoresForm.get('gmatScore')?.touched}" />
                <div class="ts-error-slot">
                  <small class="p-error"
                    *ngIf="testScoresForm.get('gmatScore')?.hasError('pattern') && testScoresForm.get('gmatScore')?.touched">Only numbers allowed</small>
                  <small class="p-error"
                    *ngIf="testScoresForm.get('gmatScore')?.hasError('scoreRequired')">Score is also required  </small>
                </div>
              </div>
            </div>

          </div>
        </div>
      </ng-container>

    </div>
    <!-- END RIGHT COLUMN -->

  </div>

</div>

<!-- Hidden file input -->
<input type="file" #hiddenFileInput style="display: none;" (change)="onHiddenFileChange($event)"
  accept="image/*,application/pdf">

<!-- Preview Dialog -->
<p-dialog [(visible)]="displayPreviewDialog" [modal]="true" header="File Preview" [dismissableMask]="true"
  [style]="{width: 'auto', 'max-width': '90vw', 'min-width': '50vw'}">
  <div class="text-center p-4 relative" *ngIf="selectedPreviewItem" style="min-height: 250px;">
    <div *ngIf="isPreviewLoading"
      class="absolute top-0 left-0 w-full h-full flex flex-column align-items-center justify-content-center z-2 bg-white-alpha-60">
      <i class="pi pi-spinner pi-spin text-4xl text-primary mb-3"></i>
      <span class="text-600 font-medium font-bold">Loading preview...</span>
    </div>
    <img *ngIf="isImageUrl(selectedPreviewItem)" [src]="selectedPreviewItem.previewUrl"
      style="max-width: 100%; max-height: 80vh; border-radius: 8px;" (load)="onPreviewLoad()" (error)="onPreviewLoad()">
    <iframe *ngIf="isPdfUrl(selectedPreviewItem) && safePdfUrl" [src]="safePdfUrl" width="100%" height="600px"
      style="border: none; border-radius: 8px;" (load)="onPreviewLoad()">
    </iframe>
  </div>
</p-dialog>

<!-- Document-reading modal — outside form so overlay covers full viewport -->
<app-linkdindetails-fetch
  *ngIf="isDocModalVisible"
  [isVisible]="isDocModalVisible"
  [autoComplete]="false"
  [fileName]="docModalFileName"
  [initialFields]="testScoreDocFields"
  (onComplete)="onDocModalComplete()"
  (onCancel)="onDocModalCancel()"
  (onClose)="onDocModalClose()">
</app-linkdindetails-fetch>